module.exports = __webpack_public_path__ + "img/10d.4601742c.svg";